import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { UserProvider } from '../hooks/useUser';
import { commonRoutes } from '../commonPages/CommonRoutes';
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import { RequireLogin } from '../helper';
import { RequireAdminLogin } from './components/RequireAdminLogin';
import Landing from './pages/Landing';
import DocumentInterpretation from './pages/DocumentInterpretation';
import AdminPanel from './pages/AdminPanel';
import InvitationSignup from './pages/InvitationSignup';
import VnogLayout from './components/VnogLayout';
import FeedbackPrint from './pages/FeedbackPrint';

const VnogIndex = () => {
    return(
        <UserProvider mountingScreen={<></>}>
            <Helmet>
                <meta name="description" content="" />
                <meta name="keywords" content="" />
                <title>VNOG: Characteristics Estimation & Document Retrieval</title>
            </Helmet>
            <BrowserRouter future={{ v7_startTransition: true }} basename={''}>
                <Toaster />
                <Routes>
                    <Route element={<VnogLayout />}>
                        <Route path="/home" element={<RequireLogin><Home /></RequireLogin>} />
                        <Route path="/document_interpretation" element={<RequireLogin><DocumentInterpretation /></RequireLogin>} />
                        <Route path="/admin_vnog" element={<RequireAdminLogin><AdminPanel /></RequireAdminLogin>} />
                    </Route>
                    <Route path="/feedback_print/:token" element={<RequireLogin><FeedbackPrint /></RequireLogin>} />
                    <Route path="/invite/:token" element={<InvitationSignup />} />
                    <Route path="/" element={<Landing />} />
                    <Route path="*" element={<Navigate to="/" />} />
                    {commonRoutes}
                </Routes>
            </BrowserRouter>
        </UserProvider>
    )
}

export default VnogIndex;